<template>
  <div
    class="user-picker"
  >
    <div>
      <label
        for="users_select"
      >
        {{ usersLbl }}
      </label>

      <div
        class="form-group"
        v-if="suggestedUsers.length"
      >
        Suggested
        <ul
          class="list-group"
        >
          <li
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            v-for="user in suggestedUsers"
          >
            {{ user }}
            <span
              class="btn btn-sm btn-warning"
              v-on:click="onSuggestedUserSelected"
              :data-suggested-user="user"
            >
              Add
            </span>
          </li>
        </ul>
      </div>
      <div
        v-if="hideSelect"
      >
      </div>
      <div
        v-else
      >
        <select
          :name="inputName"
          id="users_select"
          class="form-control"
          ref="usersSelect"
          v-on:change="usersChanged"
          multiple
        >
          <option
            v-if="loaders.gettingUsers"
          >
            Loading {{ usersLbl }}...
          </option>
          <option
            v-for="user in users"
            :value="user.id"
            :selected="isSelected(user.id)"
          >
            {{ user.name }}
          </option>
        </select>
      </div>
      <div
        class="seach-users"
        v-if="enableSearch"
      >
        <div
          class="form-group mt-3 mb-3"
        >
          <div
            class="d-flex justify-content-between pr-0 pl-0"
          >
            <div
              :class="usersSearchInputClass"
            >
              <label class="sr-only" for="users_search">Username</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">Search Users</div>
                </div>

                <input
                  type="search"
                  id="users_search"
                  ref="usersSearch"
                  class="form-control"
                  list="found-users"
                  v-model="usersSearchQuery"
                  v-on:keydown="searchUsers"
                  v-on:change="onDatalistOptionSelect"
                />
                <datalist
                  id="found-users"
                  v-on:input="addUser"
                >
                  <option
                    v-for="user in foundUsers"
                    data-user-id="user.id"
                    :value="foundUserLbl(user)"
                  />
                </datalist>
              </div>
            </div>
            <div
              v-if="foundUserSelected"
            >
              <input
                type="hidden"
                ref="foundUserId"
                :value="foundUserSelected.value"
              />
              <button
                type="button"
                class="btn btn-primary"
                v-on:click="addUser"
              >
                Add
              </button>
            </div>
          </div>
          <div
            class="alert alert-success text-center fade-out"
            v-if="showUserAdded"
          >
            User selected! Please submit the form to update selected users.
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {
      usersSearchQuery: undefined,
      foundUsers: [],
      foundUserSelected: false,
      showUserAdded: false,
      showSearch: false
    }
  },

  props: {
    action: {
      type: String,
      default: 'getUsers'
    },

    usersLbl: {
      type: String,
      default: 'Users'
    },

    enableSearch: {
      type: Boolean,
      default: false
    },

    inputName: {
      type: String,
      default: 'user_ids'
    },

    selectedUserIds: {
      type: Array,
      default: () => []
    },

    suggestedUsers: {
      type: Array,
      default: () => []
    },

    hideSelect: {
      type: [ Boolean, String ]
    }
  },

  computed: mapState({
    base: state => state.base,
    loaders: state => state.LoaderModule.loaders,
    users: state => state.UserModule.users,

    userLbl () {
      return this.usersLbl.replace(/s$/i, '')
    },

    usersSearchInputClass () {
      return `col-${this.foundUserSelected ? '11' : '12'} pl-0 pr-0`
    }
  }),

  created () {
    this.get()
  },

  methods: {
    addUser () {
      const userId = this.$refs.foundUserId.value

      let userOptionNode = this.getUserNodeByUserId(userId)
      userOptionNode.selected = true
      this.showUserAdded = true
      this.usersSearchQuery = ''

      this.usersChanged()
      this.toggleSearch()
    },

    usersChanged (ev) {
      const userIds = [...this.$refs.usersSelect.options].filter(
        option => option.selected
      ).map(option => option.value)

      this.$emit('users-changed', userIds)
    },

    foundUserLbl (user) {
      return user.name + (
        user.selected ? ' (Selected)' : ''
      )
    },

    isSelected (userId) {
      return this.selectedUserIds.includes(userId)
    },

    get () {
      this.$store.dispatch(
        `UserModule/${this.action}`
      ).catch(this.$root.processErrors).then(() => {
        this.$store.commit(
          `UserModule/filterUnnamedUsers`
        )
      })
    },

    getUserNodeByUserId (userId) {
      return this.getDOMUsersOptions().find(opt => opt.value === userId)
    },

    getUserByQuery (query) {
      return this.getDOMUsersOptions().find(
        opt => opt.innerText.trim() === query
      )
    },

    getUsersNodesByQuery (query) {
      return this.getDOMUsersOptions().filter(
        user => user.innerText.trim().toUpperCase().includes(
          query.toUpperCase()
        )
      )
    },

    focusSearch () {
      this.$refs.usersSearch.focus()
    },

    onSuggestedUserSelected (ev) {
      let user = this.getUserByQuery(
        ev.target.dataset.suggestedUser
      )
      user.selected = true
    },

    filterUsersByQuery (query) {
      return this.users.filter(
        user => user.name.trim().toUpperCase().includes(
          query.toUpperCase()
        )
      )
    },

    onDatalistOptionSelect (ev) {
      ev.target.disabled = true
      this.requestFoundUserConfirmation = true
    },

    searchUsers (ev) {
      const query = ev.target.value.trim()
      this.foundUsers = this.filterUsersByQuery(query)

      /*
      // Not sure why we were using DOM access for this
      // versus retrieved users.
      //
      // @deprecate Figure out why first
      this.foundUserSelected = this.getUserByQuery(query)

      if (!this.foundUserSelected) {
        this.foundUsers = this.getUsersNodesByQuery(query).map(user => (
          {
            name: user.innerText.trim(),
            id: user.value,
            selected: this.isSelected(user.value)
          }
        ))
      }
      */
    },

    getSuggestedUsers () {
      return this.getDOMUsers().join(',')
    },

    getDOMUsers () {
      return this.getDOMUsersOptions().map(user => user.innerText.trim())
    },

    getDOMUsersOptions () {
      return Array.from(
        this.$refs.usersSelect.options
      ).map(opt => opt)
    },

    toggleSearch () {
      this.showSearch = !this.showSearch

      if (this.showSearch && this.foundUserSelected) {
        this.showUserAdded = false
      }
    }
  }
}
</script>

<style scoped>
.user-picker select {
  height: 10rem;
}

.user-picker select,
.user-picker option {
  width: 100% !important;
}

.fade-out {
  animation-delay: 5s;
  animation-name: fadeOut;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/UserPicker.vue